import alphabetSort from 'helpers/alphabetSort'
import { ArrowDownRegions } from 'media/icons'
import React, { useEffect, useState } from 'react'
import { StyledBranchCard, StyledBranchList, StyledBranchListWrapper } from './styled'

const BranchList = ({ title, currentShop: currentShopId, changeShop, branchList }) => {
	const currentShop = branchList.find(({ id }) => +id === +currentShopId) || {}
	const currentShopName = currentShop?.name
	const [listVisible, setListVisible] = useState(false)

	const fitleredBranchList = branchList
		.filter(({ cashRegisters, name }) => cashRegisters.length && name)
		.sort(alphabetSort)

	useEffect(() => {
		if(!currentShopId) {
			changeShop(fitleredBranchList[0].id)
		}
	}, [])

	const onBranchTitleClick = (id) => () => {
		changeShop(id)
		setListVisible(false)
	}

	return(
		<StyledBranchListWrapper
			listVisible={listVisible}
		>
			<h2>{title}</h2>
			<div className='branchListAndTitle'>
				<span
					className='branchListTitle'
					onClick={() => {
						setListVisible((oldValue) => !oldValue)
					}}
				>
					{currentShopName}
					<ArrowDownRegions />
				</span>
				{
					listVisible && (
						<StyledBranchList>
							{
								fitleredBranchList
									.map((shop) => {
										const { id, name } = shop
										return (
											<StyledBranchCard
												key={id}
												onClick={onBranchTitleClick(id)}
											>
												<h3>{name}</h3>
											</StyledBranchCard>
										)
									})
							}
						</StyledBranchList>
					)
				}
			</div>
		</StyledBranchListWrapper>
	)
}

export default BranchList
